export default class LocalStore {
    static get(key) {
        if (localStorage.getItem(key) == null) return null;
        return JSON.parse(localStorage.getItem(key));
    }
    static set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    static remove(key) {
        localStorage.removeItem(key);
    }
    static clear() {
        localStorage.clear();
    }
}